/*=========================================================================================
  File Name: moduleSchedule.js
  Description: Schedule Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleRoutingState.js";
import mutations from "./moduleRoutingMutations.js";
import actions from "./moduleRoutingActions.js";
import getters from "./moduleRoutingGetters.js";

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
